import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: `'Montserrat', sans-serif`,
    fontOpticalSizing: "auto",
    fontStyle: "normal",
  },
});

export default theme;
